<template>
  <component :is="chartComponent">
    <template slot="value">
      <value-component
        v-for="(value, index) in translatedValues"
        :key="index"
        :value="value"
      />
    </template>
  </component>
</template>
<script>
import coordinateTranslators
  from '@/domain/components/installation/engineering/chromatography/polygonalChart/coordinateTranslators';
import Components from '../../../../../data/installation/engineering/chromatography/polygonalChart/components';
import ValueComponent from './Value';
import { DEFAULT_VIRTUAL_SOURCE_MAX } from './coordinateTranslators/gasRatio/builder';

export default {
  components: {
    ValueComponent,
  },
  props: {
    /**
     * Array de valores para o gráfico.
     * @type {import('./index.vue').ColoredChartValue[]}
     */
    value: {
      type: Array,
    },
    /**
     * Tipo do gráfico.
     * @type {Enum}
     * Ver @/domain/enums/polygonalCharts/polygonalChart.js
     */
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    chartComponent() {
      return Components[this.type];
    },
    translatedValues() {
      let maxX = DEFAULT_VIRTUAL_SOURCE_MAX;
      let maxY = DEFAULT_VIRTUAL_SOURCE_MAX;

      this.value.forEach(({ x, y }) => {
        if (x > maxX) {
          maxX = x;
        }

        if (y > maxY) {
          maxY = y;
        }
      });

      return this.value.map(value => ({
        ...value,
        ...this.translateCoordinates(value, {
          xVirtualSourceMax: maxX,
          yVirtualSourceMax: maxY,
        }),
      }));
    },
    coordinateTranslator() {
      return coordinateTranslators[this.type];
    },
  },
  methods: {
    translateCoordinates(value, { xVirtualSourceMax, yVirtualSourceMax }) {
      const { x, y } = value;
      if (this.coordinateTranslator) {
        return this.coordinateTranslator({ x, y }, { xVirtualSourceMax, yVirtualSourceMax });
      }

      return { x, y };
    },
  },
};
</script>
